/*
 * Shared drawing frame for every tooth component.
 *
 * All shapes are authored in the same 100 x 100 user space, centred on CX.
 * Upper teeth are drawn with the root apex at the top (y ~ 4) and the
 * incisal/occlusal surface at the bottom (y ~ 96); lower teeth are drawn the
 * other way round. Nothing is flipped vertically, so the two jaws keep their
 * own anatomy instead of being mirror copies of each other.
 *
 * Mesial (midline) side is always the LEFT side of the drawing, which makes
 * quadrants 2 and 3 render as authored and quadrants 1 and 4 a horizontal
 * mirror — the dentally correct relation between the two sides of the arch.
 */
export const CX = 50;
export const VB_HEIGHT = 100;

/* Horizontal breathing room added to each side of a tooth's own half width. */
export const PAD = 2;

/* Rendered height of one jaw row, in pixels. Keeps the 32-tooth arch around
 * 700px wide, so it fits a desktop card and scrolls horizontally on tablets
 * instead of being squeezed. */
export const ROW_HEIGHT = 80;
